import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "../Reveal";
import { Send } from "lucide-react";

const TelegramCta = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="telegram-section" className="mx-auto max-w-7xl px-6 pb-24 lg:px-10 lg:pb-32">
      <Reveal>
        <div className="glass-panel flex flex-col items-start justify-between gap-8 rounded-3xl p-10 md:flex-row md:items-center md:p-14">
          <div>
            <p className="overline-tag">{t.telegram.overline}</p>
            <h3 className="mt-3 font-display text-2xl font-bold md:text-3xl">{t.telegram.title}</h3>
            <p className="mt-3 max-w-lg text-sm text-zinc-400 md:text-base">{t.telegram.sub}</p>
          </div>
          <a href="https://t.me/SawtlyBot" target="_blank" rel="noreferrer" data-testid="telegram-cta" className="btn-ghost shrink-0">
            <Send size={16} /> {t.telegram.cta}
          </a>
        </div>
      </Reveal>
    </section>
  );
};

export default TelegramCta;
